export const DATE_FORMATS = {
  MONTH_DAY_YEAR: "MM/dd/yyyy",
  MONTH_DAY_YEAR_SHORT: "M/d/yy",
  YEAR_MONTH_DAY: "yyyy-MM-dd",
  EFFECTIVE_DATE: "ISO",
  EXPIRATION_DATE: "ISO",
  BIRTH_DATE: "MM/dd/yyyy"
};
